/* import __COLOCATED_TEMPLATE__ from './request-access.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type { StandalonePlatform } from 'embercom/objects/standalone/constants';

interface Args {}

export default class StandaloneRequestAccess extends Component<Args> {
  @service declare appService: AppService;

  get platformUrl() {
    return this.appService.mainStandalonePlatform.componentData['request-access']?.platformUrl;
  }

  get platformName(): StandalonePlatform {
    return this.appService.mainStandalonePlatform.componentData['request-access']
      ?.platformName as StandalonePlatform;
  }

  get imageUrl() {
    return this.appService.mainStandalonePlatform.componentData['request-access']?.imageUrl;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::RequestAccess': typeof StandaloneRequestAccess;
  }
}
